import axios from "axios"
import axiosRetry from "axios-retry"
import defaultHeaders from "../ntuc/headers"

const client = axios.create({
    baseURL: window.myNtucConfig.linkPassBaseUrl,
})

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

const getUser = () => {
    return client.get<LinkPassUser>(
        `user/profile`, {
            headers: defaultHeaders(),
            withCredentials: false,
        },
    )
}

export { getUser }

interface LinkPassUser {
    uid: string,
    name: string,
    country_code: string,
    phone_number: string,
    email: string,
    association: {
        auth0: string,
        linkplus: string,
    },
    created_at: string,
    updated_at: string,
    email_last_verified: string | null,
    phone_number_last_verified: string | null,
    preferences: {
        linkplus: {
            channels: {
                email: boolean,
                mail: boolean,
                text: boolean,
                voice: boolean
            }
        }
    },
    myinfo_last_verified: string | null,
    memberships: object | null
}
